"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconAmex = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const IconAmex = (_a) => {
    var { title, titleId } = _a, props = __rest(_a, ["title", "titleId"]);
    return ((0, jsx_runtime_1.jsxs)("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", "aria-labelledby": titleId }, props, { children: [title ? (0, jsx_runtime_1.jsx)("title", { id: titleId, children: title }) : null, (0, jsx_runtime_1.jsxs)("g", { fill: "none", fillRule: "evenodd", children: [(0, jsx_runtime_1.jsx)("path", { d: "M0 0h24v24H0z" }), (0, jsx_runtime_1.jsxs)("g", { fillRule: "nonzero", transform: "translate(2.5 6)", children: [(0, jsx_runtime_1.jsx)("rect", { width: 19, height: 12, fill: "#006FCF", rx: 1 }), (0, jsx_runtime_1.jsx)("path", { fill: "#FFF", d: "m11.06 6.338 1.376 1.492 1.39-1.492H15.5l-2.25 2.318L15.5 11h-1.701l-1.39-1.505L11.012 11H9.358l2.237-2.33-2.237-2.332zm-1.702 0v1.08H6.612v.725H9.29v1.052H6.612v.726h2.746V11h-4.04V6.338zm6.142.97v2.712l-1.303-1.362zM11.385 1l1.057 2.904L13.507 1H15.5v4.662h-1.281v-3.27l-1.22 3.27h-1.14l-1.22-3.263v3.263H9.358V1zM7.263 1l2.095 4.662H7.9l-.4-.932H5.317l-.393.932H3.5L5.595 1zm-.854 1.159-.645 1.525h1.289z" })] })] })] })));
};
exports.IconAmex = IconAmex;
exports.IconAmex.defaultProps = {
    height: '30px',
    width: '30px',
};
exports.default = exports.IconAmex;
